import GameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";
import GatewayResult from "model/gameplay/records/results/gateway-result";

export default class CGIsGateway extends Decision {
    public evaluate() {
        const gameplay = GameState.getCurrentGame();
        let record = gameplay.getRootRecord();

        if (!(record instanceof SpinRecord) && record.lastChild) {
            record = record.parent;
        }

        const freespinsPending = gameplay.areFreespinsPending();
        const hasPlayedSomeFreespins = gameplay.getFreespinsPlayed() > 0;
        const playedFreespins = gameplay.allFreespinsPlayed();
        const hasFreespins = gameplay.getTotalFreespinsWon() > 0;

        const isFreespins = (freespinsPending && hasPlayedSomeFreespins) || hasFreespins && playedFreespins;

        if (isFreespins) {
            return Exit.False;
        }

        const hasGatewayResult = record.getResultsOfType(GatewayResult).length > 0;
        const gatewayResultUnplayed = record.getResultsOfType(GatewayResult).every((result) => !result.played);

        return hasGatewayResult && gatewayResultUnplayed ? Exit.True : Exit.False;
    }
}
